// extracted by mini-css-extract-plugin
export default {"container":"small_text_button-module__container--2IDCr"};